/**
 * Trim a character of the left end of a string.
 */
export function ltrim(str: string, char: string): string {
  return str.startsWith(char) ? str.substring(1) : str;
}
